<template>
  <router-view/>
</template>

<style>
#app {
  font-family: industry, sans-serif;
}

</style>
